// extracted by mini-css-extract-plugin
export default {"info_card":"styles_info_card__88wLa","info_label":"styles_info_label__fzN6b","info_value":"styles_info_value__a-hGd","info_link":"styles_info_link__s-Tmb"};